if (!customElements.get("stash-bundle-quantity-selector")) {
  class StashBundleQuantitySelector extends HTMLElement {
    constructor() {
      super();

      // Store current purchase type state
      this.purchaseType = {
        isOneTime: true,
        hasSubscription: false,
      };

      // Store button references
      this.quantityButtons = [];
      this.bundleButton = null;

      // Store currently selected button
      this.selectedButton = null;

      // Store form reference
      this.productForm = null;
    }

    connectedCallback() {
      // Detect initial state on page load
      this.detectPurchaseType();

      // Set up button listeners
      this.setupButtonListeners();

      // Find and set initially active button
      this.setInitialActiveButton();

      // Set up form submission listener
      this.setupFormListener();

      // Set initial inactive state based on purchase type
      //this.updateButtonInactiveState();

      // Set initial price container visibility
      this.updatePriceContainerVisibility();

      // Set initial discount value visibility
      this.updateDiscountValueVisibility();

      // Set initial ATC price
      this.updateATCPrice();

      this.setupSubscriptionSync();
      // if(this.quantityButtons.length > 1 ){
      //   if(window.triggerClick == true){
      //     this.quantityButtons[0].dispatchEvent(new Event("click"));
      //   }
        
      // }
      // if(this.bundleButton.length > 0){
      //   if(window.triggerClick == true){
          
      //   this.bundleButton[0].dispatchEvent(new Event("click"));
         
      // }
      // }
    }

    updateVariantId(button) {
      const variantInput = document.querySelector('input[name="id"]');

      variantInput.value = button.dataset.variantId;
    }

    detectPurchaseType() {
      const sellingPlanInput = document.querySelector("[data-selling-plan-input]");

      const hasSubscription = !!sellingPlanInput?.value;

      this.purchaseType = {
        isOneTime: !hasSubscription,

        hasSubscription,
      };

      return this.purchaseType;
    }


    /**
     * Sets up event listeners for quantity and bundle buttons
     */
    setupButtonListeners() {
      // This method finds all relevant buttons and attaches click listeners to them

      // Find all Sellilng Plan buttons
      this.sellingPlanButtons = Array.from(document.querySelectorAll(".selling-plan-button"));

      // Find all quantity buttons
      this.quantityButtons = Array.from(this.querySelectorAll("[data-quantity]"));
      console.log("Quantity buttons found:", this.querySelectorAll("[data-quantity]").length);
      // Find bundle button
      this.bundleButton = this.querySelectorAll("[data-bundle-product-id]");

      // Check and log selling plans attribute for all buttons
      this.checkSellingPlansAttribute();

      // Add click listeners to quantity buttons
      this.quantityButtons.forEach((button) => {
        button.addEventListener("click", () => {
          this.handleButtonClick(button, "quantity");
        });
      });

      // Add click listener to bundle button if it exists
      if (this.bundleButton.length > 0) {
        this.bundleButton.forEach((button) => {
          button.addEventListener("click", () => {
            this.handleButtonClick(button, "bundle");
          });
        });
      }


      
    }

    /**
     * Checks for data-has-selling-plans attribute on all buttons
     */
    checkSellingPlansAttribute() {
      // This method can be used for future validation if needed
      // Currently just checking that buttons exist with the attribute
    }
   
    setInitialActiveButton() {
      
      const activeButton = this.querySelector(".td-quantity-button--active");

      if (!activeButton) return;

      this.selectedButton = activeButton;

      if (activeButton.hasAttribute("data-quantity")) {
        this.updateQuantityInput(activeButton);

        this.updateVariantId(activeButton); 
      }

      this.updateATCPrice();
    }

    /**
     * Handles button click events
     */
    handleButtonClick(button, buttonType) {
      
      const bundleItemId = button.dataset.bundleItemId;
      // Remove active class from all buttons
      this.quantityButtons.forEach((btn) => {
        btn.classList.remove("td-quantity-button--active");
        const circle = btn.querySelector('.circle');
        if(circle){
          circle.classList.remove('active')
        }
      });
      if (this.bundleButton.length > 0) {
        this.bundleButton.forEach((btn) => {
          btn.classList.remove("td-quantity-button--active");
          const circle = btn.querySelector('.circle');
          if(circle){
            circle.classList.remove('active')
          }
        });
      }

      // Add active class to clicked button
      button.classList.add("td-quantity-button--active");
      const circle = button.querySelector('.circle');
      if(circle){
        circle.classList.add('active')
      }

      // Update selected button reference
      this.selectedButton = button;

      // Update bundle additional info container class
      this.updateBundleAdditionalInfoContainer(bundleItemId);

      // Update Subscribe button inactive state based on clicked button's selling plans
      this.toggleSubscriptionButtonState(button);

      // Update ATC price
      this.updateATCPrice();
      const subscriptionWidget = document.querySelector("stash-subscription-widget");
      // Update quantity input if it's a quantity button (not bundle)
      if (buttonType === "quantity") {
        this.updateQuantityInput(button);

        if (subscriptionWidget) {
          subscriptionWidget.style.display = '';
          const subPrice = button.dataset.subscriptionPrice;
          const subPriceElement = document.querySelector("#subPrice");
          subPriceElement.textContent = subPrice;
        }
      }

      if(buttonType === "bundle"){
        

        if (subscriptionWidget) {
          subscriptionWidget.style.display = 'none';
        }

      }
      this.updateVariantId(button);
      //this.selectedButton.dispatchEvent(new Event("click"));
    }

    setupSubscriptionSync() {
      const widget = document.querySelector("stash-subscription-widget");

      if (!widget) return;

      widget.addEventListener("selling-plan-changed", () => {
        this.detectPurchaseType();

        this.updateButtonInactiveState();

        this.updatePriceContainerVisibility();

        this.updateATCPrice();
      });
    }

    /**
     * Sets up form submission listener for bundle products
     */
    setupFormListener() {
      const quantityInput = this.querySelector(".td-quantity-input");
      if (!quantityInput) return;

      const formId = quantityInput.getAttribute("form");
      if (!formId) return;

      this.productForm = document.getElementById(formId);

      if (!this.productForm) return;

      // Native submit interception
      this.productForm.addEventListener(
        "submit",
        (event) => {
          if (!this.isBundleSelected()) return;

          event.preventDefault();
          event.stopImmediatePropagation();

          this.handleBundleProductSubmission(event);
        },
        true,
      );

      // Button click interception
      const submitButton = this.productForm.querySelector('[type="submit"]');

      if (submitButton) {
        submitButton.addEventListener(
          "click",
          (event) => {
            if (!this.isBundleSelected()) return;

            event.preventDefault();
            event.stopImmediatePropagation();

            this.handleBundleProductSubmission(event);
          },
          true,
        );
      }
    }

    /**
     * Checks if bundle product is currently selected
     */
    isBundleSelected() {
      return this.selectedButton && this.selectedButton.hasAttribute("data-bundle-product-id");
    }
    /**
     * Updates the bundle additional info container class based on bundle selection
     */
    updateBundleAdditionalInfoContainer(bundleItemId) {
      const container = document.querySelector(`[data-bundle-additional-info-container][data-bundle-item-id='${bundleItemId}']`);
      const allContainers = document.querySelectorAll(`[data-bundle-additional-info-container]`);
      const savingsContainer = document.querySelector(`.stash-bundle-info__savings[data-bundle-item-id='${bundleItemId}']`);
      const allSavingsContainer = document.querySelectorAll(`.stash-bundle-info__savings`);
      console.log(container, savingsContainer)
      if (container ) {
        if (this.isBundleSelected() && window.hasBundle) {
          allContainers.forEach((container) => {
            container.classList.remove("stash-quantity-buttons__additional-info-container--active");
          })
          allSavingsContainer.forEach((savings) => {
            savings.classList.remove("stash-bundle-info__savings--active");
          })
          if(container.dataset.bundleItemId == bundleItemId ){
            container.classList.add("stash-quantity-buttons__additional-info-container--active");
          }else{
            container.classList.remove("stash-quantity-buttons__additional-info-container--active");
          }
          // if(savingsContainer.dataset.bundleItemId == bundleItemId ){
          //   savingsContainer.classList.add("stash-bundle-info__savings--active");
          // }else{
          //   savingsContainer.classList.remove("stash-bundle-info__savings--active");
          // }
        } else {
          allContainers.forEach((container) => {
            container.classList.remove("stash-quantity-buttons__additional-info-container--active");
          })
          allSavingsContainer.forEach((savings) => {
            savings.classList.remove("stash-bundle-info__savings--active");
          })
        }
      }else{
         allContainers.forEach((container) => {
            container.classList.remove("stash-quantity-buttons__additional-info-container--active");
          })
          allSavingsContainer.forEach((savings) => {
            savings.classList.remove("stash-bundle-info__savings--active");
          })
      }
    }

    /**
     * Handles bundle product form submission
     */
    handleBundleProductSubmission(event) {
      // Prevent default form submission
      event.preventDefault();
      event.stopPropagation();

      // Get bundle product info from selected button
      const bundleVariantId = this.selectedButton.getAttribute("data-bundle-product-variant-id");

      if (!bundleVariantId) {
        console.error("[Bundle Quantity Selector] Bundle variant ID not found");
        return;
      }

      // Prepare cart data
      const cartData = {
        items: [
          {
            id: bundleVariantId,
            quantity: 1,
          },
        ],
      };

      // Add bundle product to cart
      this.addBundleProductToCart(bundleVariantId);
    }

    async addBundleProductToCart(bundleVariantId) {
      const form = this.closest("form");
      const cartDrawer = document.querySelector("cart-drawer");
      const formData = new FormData();

      formData.append("id", bundleVariantId);
      formData.append("quantity", 1);

      const loader = document.querySelector(".loading-overlay__spinner");
      if (!loader) {
        alert("not found");
      }
      const submitButton = document.querySelector('[type="submit"]');

      if (loader && submitButton) {
        submitButton.classList.add("loading");
        loader.classList.remove("hidden");
        submitButton.setAttribute("aria-disabled", true);
      }

      if (cartDrawer && typeof cartDrawer.getSectionsToRender === "function") {
        formData.append(
          "sections",
          cartDrawer.getSectionsToRender().map((section) => section.id),
        );
      } else {
        formData.append("sections", []);
      }

      formData.append("sections_url", window.location.pathname);
      //formData.append("selling_plan", "691431735645");
      const config = fetchConfig("javascript");
      config.headers["X-Requested-With"] = "XMLHttpRequest";

      delete config.headers["Content-Type"];
      config.body = formData;

      const response = await fetch(routes.cart_add_url, config);
      const responseJson = await response.json();

      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: "bundle-selector",
        productVariantId: bundleVariantId,
        cartData: responseJson,
      });

      const isClosedCart = !document.body.classList.contains("page-overlay-cart-on");
      cartDrawer.renderContents(responseJson, isClosedCart);
      setTimeout(() => {
        if (loader && submitButton) {
          submitButton.classList.remove("loading");
          loader.classList.add("hidden");
          submitButton.setAttribute("aria-disabled", false);
        }
      }, 500);
    }

    /**
     * Updates inactive state of Subscribe button based on clicked button's selling plans
     * FIXME: remove
     */
    toggleSubscriptionButtonState(button) {
      const subscribeButton = document.querySelector("#subscription-option");
      if (!subscribeButton) return;

      // Check if clicked button has selling plans
      const hasSellingPlans = button.getAttribute("data-has-selling-plans") === "true";

      // Set display: none if button has no selling plans, otherwise show it
      subscribeButton.style.display = hasSellingPlans ? "" : "none";
    }


    /**
     * Updates inactive state of buttons based on purchase type
     * When subscription is selected, hides buttons without selling plans
     * When one-time is selected, shows all buttons
     */
    updateButtonInactiveState() {
      
      // If subscription is selected
      if (this.purchaseType.hasSubscription) {
        // Hide quantity buttons without selling plans
        this.quantityButtons.forEach((button) => {
          const hasSellingPlans = button.getAttribute("data-has-selling-plans") === "true";
          button.style.display = hasSellingPlans ? "" : "none";
        });

        // Hide bundle button if it doesn't have selling plans
        // if (this.bundleButton.length > 0) {
        //   const hasSellingPlans = this.bundleButton.getAttribute("data-has-selling-plans") === "true";
        //   this.bundleButton.style.display = hasSellingPlans ? "" : "none";
        // }
        this.bundleButton.forEach((button)=>{
          const hasSellingPlans = button.getAttribute("data-has-selling-plans") === "true";
          //button.style.display = hasSellingPlans ? "" : "none";
          button.classList.toggle('disabled');
          button.toggleAttribute('disabled');
        })
      } else {
        // One-time purchase selected - show all buttons
        this.quantityButtons.forEach((button) => {
          button.style.display = "";
        });

        // if (this.bundleButton.length > 0) {
        //   this.bundleButton.style.display = "";
        // }

        this.bundleButton.forEach((button)=>{
          //button.style.display = "";
          button.classList.toggle('disabled');
          button.toggleAttribute('disabled');
        })
      }
    }

    /**
     * Updates price container visibility based on purchase type
     * Shows one-time price container when one-time is selected
     * Shows subscription price container when subscription is selected
     */
    updatePriceContainerVisibility() {
      const allButtons = [...this.quantityButtons];
      if (this.bundleButton.length > 0 ) {
        allButtons.push(...this.bundleButton);
      }

      allButtons.forEach((button) => {
        const oneTimeContainer = button.querySelector(".td-quantity-buttons__one-time-price-container");
        const subscriptionContainer = button.querySelector(".td-quantity-buttons__subscription-price-container");

        if (this.purchaseType.isOneTime) {
          // Show one-time container, hide subscription container
          if (oneTimeContainer) {
            oneTimeContainer.style.display = "flex";
          }
          if (subscriptionContainer) {
            subscriptionContainer.style.display = "none";
          }
        } else if (this.purchaseType.hasSubscription && window.isV2 != true) {
          
          // Show subscription container, hide one-time container
          if (oneTimeContainer) {
            oneTimeContainer.style.display = "none";
          }
          if (subscriptionContainer) {
            subscriptionContainer.style.display = "flex";
          }
        }
      });
    }

    /**
     * Updates visibility of discount value divs based on purchase type
     */
    updateDiscountValueVisibility() {
      
      const allButtons = [...this.quantityButtons];
      if (this.bundleButton.length > 0) {
        allButtons.push(...this.bundleButton);
      }

      allButtons.forEach((button) => {
        const oneTimeDiscount = button.querySelector(".td-quantity__one-time-discount-value");
        const subscriptionDiscount = button.querySelector(".td-quantity__subscription-discount-value");

        if (this.purchaseType.isOneTime) {
          // Show one-time discount, hide subscription discount
          if (oneTimeDiscount) {
            oneTimeDiscount.style.display = "block";
          }
          if (subscriptionDiscount) {
            subscriptionDiscount.style.display = "none";
          }
        } else if (this.purchaseType.hasSubscription) {
          // Show subscription discount, hide one-time discount
          if (oneTimeDiscount) {
            oneTimeDiscount.style.display = "none";
          }
          if (subscriptionDiscount) {
            subscriptionDiscount.style.display = "block";
          }
        }
      });
    }

    /**
     * Updates the quantity input field based on selected quantity button
     */
    updateQuantityInput(button) {
      // Find the quantity input field
      const quantityInput = this.querySelector(".td-quantity-input");
      if (!quantityInput) return;

      // Get quantity from button's data attribute
      const quantity = button.getAttribute("data-quantity");
      if (quantity) {
        quantityInput.value = quantity;
      }
    }

    /**
     * Updates the add to cart button price based on selected button and purchase type
     */
    updateATCPrice() {
      // Find ATC price elements
      const atcPriceElement = document.querySelector("[data-quantity-price]");
      const atcComparePriceElement = document.querySelector("[data-quantity-compare-price]");

      if (!atcPriceElement || !this.selectedButton) return;

      // Get price values from selected button based on purchase type
      let price = "";
      let comparePrice = "";

      if (this.purchaseType.isOneTime) {
        price = this.selectedButton.getAttribute("data-one-time-price") || "";
        comparePrice = this.selectedButton.getAttribute("data-one-time-compare-price") || "";
      } else if (this.purchaseType.hasSubscription) {
        price = this.selectedButton.getAttribute("data-subscription-price") || "";
        comparePrice = this.selectedButton.getAttribute("data-subscription-compare-price") || "";
      }

      // Update price element
      if (price) {
        atcPriceElement.textContent = price;
      }

      // Update compare price element
      if (atcComparePriceElement) {
        if (comparePrice && comparePrice !== price) {
          atcComparePriceElement.textContent = comparePrice;
          atcComparePriceElement.classList.add("product__price--compare-active");
        } else {
          atcComparePriceElement.classList.remove("product__price--compare-active");
        }
      }
    }

  }

  customElements.define("stash-bundle-quantity-selector", StashBundleQuantitySelector);
}